/* global drupalSettings Drupal, jQuery */

(function ($, Drupal, drupalSettings) {
	'use strict';

	Drupal.behaviors.filters = {
		attach: function (context, drupalSettings) {
			// GO après chargement 🚀

			const selectWrapper = (select, options) => {
				// Hides the select element
				select.classList.add('s-hidden');

				// Wrap the select element in a div
				const wrapper = document.createElement('div');
				wrapper.classList.add('select');
				select.closest('.form__field').appendChild(wrapper);
				wrapper.appendChild(select);

				const customSelect = document.createElement('div');
				customSelect.classList.add(
					'custom-select',
					select.getAttribute('data-drupal-selector')
				);
				wrapper.appendChild(customSelect);

				// Show the first select option in the styled div
				const label = select
					.closest('.form-group')
					.querySelector('label');

				customSelect.textContent = label.textContent;
				label.style.display = 'none';
				if (options[select.selectedIndex].value !== 'All') {
					wrapper.classList.add('selected');
				}

				// Insert an unordered list after the styled div and also cache the list
				const list = document.createElement('ul');
				list.classList.add('options');
				wrapper.appendChild(list);

				// Insert a list item into the unordered list for each select option
				for (let i = 0; i < options.length; i++) {
					const item = document.createElement('li');
					item.textContent = options[i].textContent;
					item.setAttribute('rel', options[i].value);
					if (options[i].getAttribute('selected')) {
						item.classList.add('selected');
					}
					list.appendChild(item);
				}

				toggleSelect(wrapper);
				selectOption(list, customSelect);
			};

			// Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
			const toggleSelect = (customSelect) => {
				customSelect.addEventListener('click', (e) => {
					e.stopPropagation();
					if (customSelect.classList.contains('active')) {
						customSelect.classList.remove('active');
						customSelect.nextElementSibling.style.display = 'none';
					} else {
						document
							.querySelectorAll('.custom-select')
							.forEach((custom) => {
								custom.classList.remove('active');
							});
						customSelect.classList.add('active');
					}
				});
			};

			const selectOption = (list, customSelect) => {
				// Cache the list items
				const listItems = list.querySelectorAll('li');

				// Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
				// Updates the select element to have the value of the equivalent option
				listItems.forEach((item) => {
					item.addEventListener('click', (e) => {
						e.stopPropagation();
						const optionVal = item.getAttribute('rel');
						const previous = customSelect.previousElementSibling;
						const option = previous.querySelector(
							`option[value="${optionVal}"]`
						);
						customSelect.textContent = item.textContent;
						customSelect.classList.remove('active');
						list.style.display = 'none';
						option.setAttribute('selected', 'selected');
						document
							.querySelector('.view-filters .js-form-submit')
							.click();
					});
				});
			};

			const editTextPlaceholder = () => {
				const editText = document.querySelector(
					'[data-drupal-selector="edit-text"]'
				);
				const label = editText
					.closest('.form-group')
					.querySelector('label').textContent;
				editText.setAttribute('placeholder', label);
			};

			// Hides the unordered list when clicking outside of it
			// document.querySelector(document).click(function () {
			//     $custom-select.removeClass('active');
			//     $list.hide();
			// });

			$(context)
				.find('.view-filters')
				.once('filters')
				.each(function () {
					const root = document.querySelector('.view-filters');

					if (root) {
						const selects = document.querySelectorAll('select');
						selects.forEach((select) => {
							const options = select.querySelectorAll('option');
							selectWrapper(select, options);
						});

						editTextPlaceholder();
					}
				});
		},
	};
})(jQuery, Drupal, drupalSettings);
